import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from "../../assets/logo.png"; // Ensure this path matches your project structure

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isServicesOpenMobile, setIsServicesOpenMobile] = useState(false);

  const location = useLocation();
  const currentPath = location.pathname;

  const services = [
    { name: "New Medical College Establishment", href: "/services/new-medical-college-establishment", desc: "Flagship advisory from concept to readiness." },
    { name: "MBBS Seat Expansion", href: "/services/mbbs-seat-expansion", desc: "Professional advisory for increased admission intake." },
    { name: "PG (MD/MS) Course & Seat Expansion", href: "/services/pg-course-seat-expansion", desc: "Advancing postgraduate medical education." },
    { name: "Institutional & Teaching Hospital Compliance", href: "/services/institutional-compliance", desc: "Strengthening academic & clinical preparedness." },
    { name: "Documentation & Institutional Readiness", href: "/services/documentation-readiness", desc: "Structured documentation and gap identification." },
    { name: "Medical Faculty Recruitment", href: "/services/medical-faculty-recruitment", desc: "Permanent & full-time academic manpower." },
  ];

  // Helper to check active state
  const isActive = (path) => {
    if (path === '/') return currentPath === '/';
    return currentPath === path;
  };

  // Check if any service subpage is active
  const isServicesActive = currentPath === '/services' || currentPath.startsWith('/services/');

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      document.body.style.overflow = '';
    };
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setIsMobileMenuOpen(false);
    setIsServicesOpenMobile(false);
    document.body.style.overflow = '';
  }, [location]);

  const toggleMobileMenu = () => {
    const nextState = !isMobileMenuOpen;
    setIsMobileMenuOpen(nextState);
    setIsServicesOpenMobile(false);
    document.body.style.overflow = nextState ? 'hidden' : '';
  };

  // Desktop: Navigates to /services on click | Mobile: Toggles dropdown only
  const handleServicesClick = (e) => {
    if (window.innerWidth <= 1200) {
      e.preventDefault();
      setIsServicesOpenMobile((prev) => !prev);
    }
  };

  return (
    <>
      {/* Mobile Menu Backdrop */}
      <div 
        className={`navbar-overlay ${isMobileMenuOpen ? 'navbar-active' : ''}`} 
        onClick={toggleMobileMenu}
      />
      
      <header className={`navbar-header ${isScrolled ? 'navbar-scrolled' : ''}`}>
        <div className="navbar-container">
          
          {/* LEFT: LOGO */}
          <div className="navbar-logo">
            <Link to="/">
              <img src={logo} alt="Nutrivio Medical Services" />
            </Link>
          </div>

          {/* CENTER & MOBILE SLIDE DRAWER */}
          <nav className={`navbar-nav-wrapper ${isMobileMenuOpen ? 'navbar-open' : ''}`}>
            
            {/* Mobile Header Inside Drawer */}
            <div className="navbar-drawer-header">
              <span className="navbar-drawer-title">Menu</span>
              <button 
                className="navbar-drawer-close" 
                onClick={toggleMobileMenu}
                aria-label="Close Menu"
              >
                ✕
              </button>
            </div>

            <ul className="navbar-menu">
              
              {/* 1. Home */}
              <li className="navbar-item">
                <Link 
                  to="/" 
                  className={`navbar-link ${isActive('/') ? 'navbar-link-active' : ''}`}
                >
                  Home
                </Link>
              </li>
              
              {/* 2. About */}
              <li className="navbar-item">
                <Link 
                  to="/about" 
                  className={`navbar-link ${isActive('/about') ? 'navbar-link-active' : ''}`}
                >
                  About
                </Link>
              </li>

              {/* 3. Services (Desktop: Click & Hover | Mobile: Dropdown Only) */}
              <li className="navbar-item navbar-has-megamenu">
                <Link 
                  to="/services" 
                  className={`navbar-link navbar-services-trigger ${isServicesActive ? 'navbar-link-active' : ''}`}
                  onClick={handleServicesClick}
                >
                  <span>Services</span>
                  <span className={`navbar-arrow ${isServicesOpenMobile ? 'navbar-arrow-open' : ''}`}></span>
                </Link>

                {/* Mega Menu Dropdown */}
                <div className={`navbar-megamenu ${isServicesOpenMobile ? 'navbar-mobile-show' : ''}`}>
                  <div className="navbar-mega-container">
                    {services.map((s, i) => (
                      <Link 
                        key={i} 
                        to={s.href} 
                        className={`navbar-mega-card ${currentPath === s.href ? 'navbar-mega-card-active' : ''}`}
                      >
                        <span className="navbar-mega-index">0{i + 1}</span>
                        <div className="navbar-mega-info">
                          <h6>{s.name}</h6>
                          <p className="navbar-service-desc">{s.desc}</p>
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              </li>

              {/* 4. Gallery */}
              <li className="navbar-item">
                <Link 
                  to="/gallery" 
                  className={`navbar-link ${isActive('/gallery') ? 'navbar-link-active' : ''}`}
                >
                  Gallery
                </Link>
              </li>

              {/* 5. For Institutions */}
              <li className="navbar-item">
                <Link 
                  to="/for-institutions" 
                  className={`navbar-link ${isActive('/for-institutions') ? 'navbar-link-active' : ''}`}
                >
                  For Institutions
                </Link>
              </li>

              {/* 6. For Medical Faculty */}
              <li className="navbar-item">
                <Link 
                  to="/for-medical-faculty" 
                  className={`navbar-link ${isActive('/for-medical-faculty') ? 'navbar-link-active' : ''}`}
                >
                  For Medical Faculty
                </Link>
              </li>
            </ul>

            {/* Mobile Drawer Bottom Action (Contact Us) */}
            {/* Mobile Drawer Bottom Action (Contact Us) */}
<div className="navbar-drawer-footer">
  <Link 
    to="/contact" 
    className={`navbar-mobile-contact-btn ${isActive('/contact') ? 'navbar-mobile-contact-active' : ''}`}
  >
    Contact Us
  </Link>
</div>
          </nav>

          {/* RIGHT: DESKTOP CONTACT ACTION & HAMBURGER */}
          <div className="navbar-right">
            <Link 
              to="/contact" 
              className={`navbar-contact-btn ${isActive('/contact') ? 'navbar-contact-active' : ''}`}
            >
              <span>Contact Us</span>
            </Link>

            <button 
              className={`navbar-hamburger ${isMobileMenuOpen ? 'navbar-active' : ''}`} 
              onClick={toggleMobileMenu}
              aria-label="Toggle Navigation Menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>

        </div>
      </header>
    </>
  );
};

export default Navbar;